"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListboxOptionMeta = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ListboxOptionMetaMixin = require("../../mixins/components/ListboxOptionMetaMixin");
/**
 * @since 8.28.0
 */
var ListboxOptionMeta = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "ListboxOptionMeta",
  componentId: "c11n-8-107-0__sc-1wsqhbt-0"
})(["", ""], _ListboxOptionMetaMixin.ListboxOptionMetaMixin);
exports.ListboxOptionMeta = ListboxOptionMeta;
ListboxOptionMeta.displayName = 'ListboxOptionMeta';

/** @component */